class MemberProductApiService {
    constructor(HttpService, SessionService) {
        'ngInject';

        this.HttpService = HttpService;
        this.SessionService = SessionService;
    }

    request(payload) {
        return this.HttpService.post('/' + this.SessionService.getLocale() + '/member/product/request', payload);
    }
}

export default MemberProductApiService;


// WEBPACK FOOTER //
// ./client/app/api/services/memberproduct.api.service.js